import { render, staticRenderFns } from "./main-sidebar.vue?vue&type=template&id=64bd8250&scoped=true"
import script from "./main-sidebar.vue?vue&type=script&lang=js"
export * from "./main-sidebar.vue?vue&type=script&lang=js"
import style0 from "./main-sidebar.vue?vue&type=style&index=0&id=64bd8250&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bd8250",
  null
  
)

export default component.exports